export const bulletListClassName = 'ml-5 list-disc marker:text-primary';

/** Green when ticked, to match the consent box's done state. */
export const consentCheckboxClassName =
  'mt-1 data-[state=checked]:border-success data-[state=checked]:bg-success data-[state=checked]:text-success-foreground';

/** Tinted until ticked so the required consent stands out, then green once given. */
export const consentBoxClassName = 'flex items-start gap-3 rounded-lg border-2 p-4 transition-colors';
export const consentBoxPendingClassName = 'border-primary bg-accent';
export const consentBoxDoneClassName = 'border-success bg-success/10';

/** An identifier marked in the step-1 dictation snippet. */
export const piiSpanClassName =
  'bg-transparent font-medium text-destructive underline decoration-destructive/40 underline-offset-4';

export const snippetTextClassName = 'leading-relaxed';

export const illustrationPendingDotClassName = 'border-2 border-border';
